export interface ParsedAuthError {
  userMessage: string;
  originalError: string;
  shouldShowLoginOption: boolean;
}

export function parseAuthError(error: any): ParsedAuthError {
  const errorMessage = error?.message || error?.error_description || "Unknown error";

  // User already exists variations
  if (
    errorMessage.includes("User already registered") ||
    errorMessage.includes("email address is already registered") ||
    errorMessage.includes("already been registered")
  ) {
    return {
      userMessage: "This email is already in use. Try logging in instead.",
      originalError: errorMessage,
      shouldShowLoginOption: true,
    };
  }

  // Invalid email format
  if (errorMessage.includes("Invalid email") || errorMessage.includes("email format")) {
    return {
      userMessage: "Please enter a valid email address.",
      originalError: errorMessage,
      shouldShowLoginOption: false,
    };
  }

  // Password requirements
  if (
    errorMessage.includes("Password") &&
    (errorMessage.includes("weak") || errorMessage.includes("short"))
  ) {
    return {
      userMessage: "Password must be at least 8 characters long.",
      originalError: errorMessage,
      shouldShowLoginOption: false,
    };
  }

  // Network/connection errors
  if (
    errorMessage.includes("network") ||
    errorMessage.includes("connection") ||
    errorMessage.includes("timeout")
  ) {
    return {
      userMessage: "Connection problem. Please check your internet and try again.",
      originalError: errorMessage,
      shouldShowLoginOption: false,
    };
  }

  // Rate limiting
  if (errorMessage.includes("rate limit") || errorMessage.includes("too many requests")) {
    return {
      userMessage: "Too many attempts. Please wait a few minutes before trying again.",
      originalError: errorMessage,
      shouldShowLoginOption: false,
    };
  }

  // Email confirmation required
  if (errorMessage.includes("Email not confirmed") || errorMessage.includes("confirm your email")) {
    return {
      userMessage: "Please check your email and click the confirmation link before logging in.",
      originalError: errorMessage,
      shouldShowLoginOption: false,
    };
  }

  // Default fallback
  return {
    userMessage:
      "Something went wrong. Please try again or contact support if the problem persists.",
    originalError: errorMessage,
    shouldShowLoginOption: false,
  };
}
